
import Vue from 'vue'
import PropertyService from '@/services/PropertyService';
import { extractErrorMessage } from '@/utils/Util';
import ImageService from '@/services/ImageService';

export default Vue.extend({
    name: 'PropertyDeleteDialog',
    props: ['property'],
    data: () => ({
        localDialog: false,
        alertText: "",
        alertVisible: false,
        alertType: "error",
        loading: false,
    }),
    methods: {
        close() {
            this.localDialog = false;
        },
        clear() {
            this.alertVisible = false;
            this.loading = false;
        },
        dismiss() {
            this.clear();
            this.close();
        },
        async confirmDelete() {
            this.loading = true;

            try {
                await PropertyService.deleteProperty(this.$root.$store.state.session.selectedTenant.uuid, this.property.uuid);

                this.alertType = "success";
                this.alertText = this.$t('property.successDelete') as string;
                this.alertVisible = true;
                this.loading = false;

                await ImageService.deleteImage("properties", this.property.uuid);

                setTimeout(() => {
                    this.$emit("delete", this.property);
                    this.dismiss();
                }, 2000);
            } catch (err) {
                console.log(err);
                this.alertType = "error";
                this.alertText = this.$t('property.errorDelete') + ' ' + extractErrorMessage(err);
                this.alertVisible = true;
                this.loading = false;
            }
        }
    }
})
